import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type TechnicalErrorBannerProps = {
  isVisible: boolean;
  text: React.ReactNode;
  onClose?: () => void;
}

export const TechnicalErrorBanner = ({
  isVisible,
  text,
  onClose,
}: TechnicalErrorBannerProps) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="mg-alert is-warning font-14 uk-width-1-1 uk-text-center">
      <FontAwesomeIcon icon="info-circle" className="mg-margin-r-5" />
      <span>{text}</span>
      {onClose && (
        <button
          className="uk-icon-button uk-margin-left"
          type="button"
          onClick={onClose}
          aria-label="Close"
        >
          <FontAwesomeIcon icon="times" />
        </button>
      )}
    </div>
  );
}
